import { Loader2 } from "lucide-react";

export default function Loader({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-16 text-[#4B5563]">
      <Loader2 className="h-5 w-5 mr-2 animate-spin" />
      <span className="bsca-eyebrow">{label}</span>
    </div>
  );
}
